// component if sub domain is saas then saas footer else footer
import React from 'react';
import SaasFooter from './SaaSFooter';
import Footer from './Footer';
import { getSubdomain, isSaaSSubdomain } from 'utils/getSubdomain';

const HorizontalFooter = () => {
  return isSaaSSubdomain() ? <SaasFooter /> : <Footer />;
};

export default HorizontalFooter;
